<template>
    <popup :show="true" width="640px" @on-close="onClose">
        <div class="move-file">
            <div class="move-file-container">
                <div class="move-file-title">移动到文件夹</div>
                <div class="move-file-desc">请选择</div>
                <div class="folder-list">
                    <folder-tree 
                        :folders="processFolders"
                        :level="0"
                        :selectedFolder="curr_folder"
                        :parentFolder="folderId"
                        @select-folder="onFolderClick"
                    />
                </div>
            </div>
            <div class="btn-box">
                <div class="btn" @click="onClose">取消</div>
                <div class="btn" @click="onConfirimMove">确定</div>
            </div>
        </div>
    </popup>
</template>
<script> 
import { teamFileMove, teamFolderFileList } from '@/api/index';
import Popup from "@/components/Popup";
import FolderTree from './FolderTree.vue';
export default{
    name:"MoveFile",
    components:{
        Popup,
        FolderTree
    },
    props:{
        teamId:{
            type:String,
            default:''
        },
        // folders:{
        //     type:Array,
        //     default:()=>[]
        // },
        file:{
            type:Object,
            default:()=>({})
        }
    },
    computed:{
        folderId(){
            console.log('folders',this.folders[0]);
            if(!this.folders.length) return '';
            return this.folders[0].uuid;
        },
        processFolders(){
            return this.folders.map((item)=>{return {...item,expanded:false}})
        }
    },
    data(){
        return{
            folders:[],
            curr_folder:{}
        }
    },
    mounted(){
        this.onGetFolderList();
    },
    methods:{
        async onGetFolderList(){
            try{
                const param = {};
                param.team_uuid = this.teamId;
                param.parent_directory_uuid = '';
                const {code,msg,data} = await teamFolderFileList(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;                
                }
                this.folders = data.filter(item=>item.is_dir);
            }catch(e){
                console.log('err-get-folder-list-move',e);
                this.$layer.msg(e.msg);
            }
        },
        async onConfirimMove(){
            try{
                console.log('on-confirm-move',this.curr_folder);
                if([1,2,3].includes(Number(this.curr_folder.type))){
                    console.log('版型/面辅料');
                    this.$emit('show-form',{type:this.curr_folder.type,folder:this.curr_folder});
                    return;
                }
                const param = {};
                param.team_uuid = this.teamId;
                param.parent_directory_uuid = this.curr_folder.uuid;
                param.file_uuid = this.file.uuid;
                param.type = this.curr_folder.type || this.file.type;
                param.info = this.file.info;
                const {code,msg} = await teamFileMove(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$emit('on-move-success');
                this.onClose();
            }catch(e){
                console.log('err-move-file',e);
                this.$layer.msg(e.msg);
            }
        },
        onFolderClick(e){
            console.log('folder-click',e);
            this.curr_folder = {...e};
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
    .move-file{
        width:100%;
        background:#ffffff;
        border-radius:15px;
        .move-file-container{
            padding:30px;
            display:flex;
            flex-direction:column;
            .move-file-title{
                color:#1a1a1a;
                font-size:24px;
                line-height:44px;
            }
            .move-file-desc{
                color:#4d4d4d;
                font-size:14px;
                line-height:44px;
            }
            .folder-list{
                width:100%;
                height:490px;
                overflow-y:scroll;
                overflow-x:hidden;
                border:1px solid #e0e0e0;
                border-radius:5px;
                padding:10px;
                &::-webkit-scrollbar{
                    display:none;
                }
            }
        }
        .btn-box{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            column-gap:10px;
            margin-bottom:30px;
            .btn{
                width:110px;
                height:32px;
                border-radius:6px;
                background:#ffffff;
                border:1px solid #dedee0;
                line-height:32px;
                text-align:center;
                cursor:pointer;
                color:#4d4d4d;
                font-size:14px;
                &:last-child{
                    color:#ffffff;
                    background:#ff5967;
                    border:none;
                }
            }
        }
    }
</style>